<div
  class="flex flex-col items-center gap-y-8 z-[9999] inset-0 bg-[#ECECECB2] fixed justify-center"
>
  <div class="w-[60px] h-[60px] overflow-hidden">
    <div
      class="inner inset-0 inline-block w-full h-full m-auto rounded-[50%] animate-spin border-t-transparent"
    ></div>
  </div>
</div>
